<button type="button" mat-button class="search-type-button" [matMenuTriggerFor]="searchTypeMenu"
  [attr.aria-label]="'searchPill.chooseWhatToSearchBy' | transloco" data-testid="search-pill-type">
  {{ selectedSearchLabel }}
  <mat-icon iconPositionEnd class="search-type-caret">arrow_drop_down</mat-icon>
</button>
<mat-menu #searchTypeMenu="matMenu">
  @for (option of searchOptions; track option.value) {
    <button type="button" mat-menu-item (click)="selectSearchType(option.value)"
      [attr.data-testid]="'search-pill-type-' + option.value">
      {{ ('searchOptions.' + option.value) | transloco }}
    </button>
  }
</mat-menu>

<span class="search-divider"></span>

<input #searchInput class="search-input" type="text" name="searchPillCriteria"
  [(ngModel)]="this.searchCriteria" (keyup.enter)="performSearch()"
  [placeholder]="'common.labels.search' | transloco" [attr.aria-label]="'searchPill.searchCriteria' | transloco" data-testid="search-pill-input">

<button type="button" mat-icon-button class="search-submit" (click)="performSearch()"
  [disabled]="!this.searchCriteria.trim()" [attr.aria-label]="'common.labels.search' | transloco" data-testid="search-pill-button">
  <mat-icon>search</mat-icon>
</button>
